import React from "react";
import { TATVA_PHOTO_WYNN_B64 } from "../lib/tatvaPhotoWynn";

/** Tether — AI Filmmaker (remote) cover letter. */

const CREAM = "#f4ede0";
const INK = "#1a1a1a";
const INK_SOFT = "#3a342b";
const BRONZE = "#8a6f47";
const RULE_SOFT = "rgba(26,26,26,0.10)";
const SERIF = '"Playfair Display", Georgia, "Times New Roman", serif';
const SANS = "Inter, -apple-system, BlinkMacSystemFont, sans-serif";

const Eyebrow = ({ children }) => (
    <p style={{ fontFamily: SANS, color: BRONZE, fontSize: 9, letterSpacing: "0.36em", textTransform: "uppercase", fontWeight: 600, margin: 0 }}>
        {children}
    </p>
);

export const TetherCoverSheet = () => (
    <article className="cover-page" data-testid="cover-letter-sheet"
        style={{ width: 794, height: 1120, maxWidth: "100%", margin: "0 auto", backgroundColor: CREAM, color: INK, boxShadow: "0 24px 60px rgba(0,0,0,0.18), 0 0 0 1px rgba(26,26,26,0.06)", padding: "56px 80px 44px", boxSizing: "border-box", fontFamily: SANS, display: "flex", flexDirection: "column", overflow: "hidden" }}>
        <header style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 22, paddingBottom: 18, borderBottom: `1px solid ${RULE_SOFT}`, marginBottom: 26 }}>
            <div style={{ flex: 1 }}>
                <h1 style={{ fontFamily: SERIF, fontSize: 32, fontWeight: 500, color: INK, margin: 0, letterSpacing: "-0.02em", lineHeight: 1 }}>Aditya Anand</h1>
                <p style={{ fontFamily: SERIF, fontStyle: "italic", fontSize: 12, color: BRONZE, margin: "4px 0 0" }}>Known professionally as Tatva K</p>
                <p style={{ fontFamily: SERIF, fontStyle: "italic", fontSize: 12, color: INK_SOFT, margin: "6px 0 0" }}>
                    AI-Native Storyteller &middot; Sound Engineer &middot; Crypto &amp; AI Operator
                </p>
                <p style={{ fontFamily: SANS, fontSize: 9.5, color: INK_SOFT, margin: "10px 0 0", letterSpacing: "0.04em", lineHeight: 1.55 }}>
                    Al Hamra Village, Ras Al Khaimah, UAE
                    <br />
                    tatvak@theresetsanctuary.org &middot; +971 50 676 9007
                </p>
            </div>
            <img src={TATVA_PHOTO_WYNN_B64} alt="Aditya Anand" style={{ width: 92, height: 110, objectFit: "cover", border: `1px solid rgba(26,26,26,0.18)`, flexShrink: 0 }} />
        </header>

        <div style={{ fontFamily: SANS, fontSize: 9.5, color: BRONZE, letterSpacing: "0.18em", textTransform: "uppercase", fontWeight: 600, margin: "0 0 22px" }}>
            Re: AI Filmmaker &middot; Remote
        </div>

        <section style={{ fontFamily: SERIF, fontSize: 12, lineHeight: 1.6, color: INK_SOFT, fontWeight: 400 }}>
            <p style={{ margin: "0 0 11px" }}>Dear hiring team at Tether,</p>

            <p style={{ margin: "0 0 11px" }}>
                I am writing to apply for the <strong style={{ color: INK }}>AI Filmmaker</strong> position. My profile
                sits at an unusual intersection that I believe maps precisely to what Tether needs: twenty years of
                professional visual and audio storytelling, hands-on crypto trading and AI R&amp;D experience inside a
                trading venture, and a current daily working stack of generative AI video tooling and Final Cut Pro X.
            </p>

            <p style={{ margin: "0 0 11px" }}>
                On <strong style={{ color: INK }}>AI filmmaking</strong>: I work daily across Kaiber AI (my primary
                generation tool), Runway, Pika and MidJourney. I edit and finish in Final Cut Pro X. Every Reset
                Sanctuary and Reel Business Inc. ad creative, reel and music-video piece on social today is produced
                and edited by me in-house using these tools. I treat the AI video stack as a daily craft, not a
                novelty, and I am quick at moving between tools as new ones emerge.
            </p>

            <p style={{ margin: "0 0 11px" }}>
                On <strong style={{ color: INK }}>crypto</strong>: I was Head of Research &amp; Development &mdash; AI
                Systems at Moneta, a crypto trading venture, from 2020 to 2022, building algorithmic models on
                large-language-model APIs for signal generation and risk modelling. I am also a personal crypto trader
                with a supply-and-demand, technical-analysis approach and a decentralised mindset. Three years ago I
                produced, edited and published a long-form explainer video on Ethereum (in Hindi, with original
                infographics) that crossed roughly 100,000 views &mdash; written, voiced, animated and cut entirely by
                me. I am not learning crypto for this role; I have been inside it as operator, trader and creator.
            </p>

            <p style={{ margin: "0 0 11px" }}>
                On <strong style={{ color: INK }}>storytelling and marketing</strong>: I bring twenty years across
                Sunburn Festival mainstage (2006&ndash;2009), thirteen years on national broadcast at Zabardast Hit
                95&nbsp;FM, a TEDx mainstage talk on sound and cognition, and an engineered catalogue past 200M streams.
                I also operate fluently in direct-response marketing &mdash; UGC ad formats, e-commerce funnels, Meta
                Pixel and Conversions API, the full ad-creative lifecycle. I understand how a film has to perform on a
                feed, not just look beautiful in a portfolio.
            </p>

            <p style={{ margin: "0 0 11px" }}>
                I work fully remote from the UAE, operate across global time zones, and ship at the volume of a small
                content team from a single studio setup. I would welcome the opportunity to discuss how I can serve
                Tether&apos;s marketing department and the wider Tether group of companies.
            </p>

            <p style={{ margin: 0 }}>Thank you for your time and consideration.</p>
        </section>

        <div style={{ marginTop: "auto", paddingTop: 22, display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
            <div>
                <p style={{ fontFamily: SERIF, fontStyle: "italic", fontSize: 22, color: INK, margin: 0, letterSpacing: "-0.01em", lineHeight: 1 }}>Warm regards,</p>
                <p style={{ fontFamily: SERIF, fontSize: 20, color: BRONZE, margin: "8px 0 0", fontWeight: 500, letterSpacing: "-0.01em" }}>Aditya Anand</p>
            </div>
            <div style={{ textAlign: "right" }}>
                <Eyebrow>Remote &middot; UAE-based</Eyebrow>
                <p style={{ fontFamily: SANS, fontSize: 9.5, color: INK_SOFT, margin: "8px 0 0", letterSpacing: "0.04em", lineHeight: 1.6 }}>
                    Available immediately
                </p>
            </div>
        </div>
    </article>
);
